import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import moment from 'jalali-moment';
import EmptyImg from '../../../../assets/image/shared/empty.svg';
import {getValidImage} from '../../../../utilities/helper/getValidImage/getValidImage';
import {discountedAdvertisementPrice} from '../../myStore/pages/manageMyStoreAds/helper/discountedAdvertisementPrice';
interface HeaderCardProps {
  data?: IAdvertisementDetail;
}
const HeaderCard = ({data}: HeaderCardProps) => {
  // Getting valid image from api result
  const mainImage = data && getValidImage(data.main_image!, 'original');
  const subBrandImage =
    data && getValidImage(data.sub_brand_main_image!, 'original');
  const displayImage = mainImage || subBrandImage;

  return (
    <div className="w-full  px-2 gap-3 bg-white items-center h-[128px] flex rounded-[8px] shadow-sm relative py-2 my-2">
      {displayImage ? (
        <div>
          <img
            className="rounded-[8px] min-w-[112px] h-[112px] object-cover"
            width={112}
            height={112}
            src={displayImage}
            alt={data.title}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center w-[112px] h-[112px] rounded-[8px] min-w-[112px] bg-gray-100">
          <img className="" width={50} height={50} src={EmptyImg} alt="" />
        </div>
      )}

      <div className="flex flex-col justify-between w-full h-full py-2">
        <div className="flex flex-col gap-2">
          <span className="text-[#1A1A1A] text-md font-Medium">
            {data?.title}
          </span>
          <div className="flex items-center gap-1 text-sm text-gray-700 font-Regular">
            <SpanIcon className="text-xl icon-nameLocation" />
            <span>
              {data?.state?.name || ''} . {data?.city?.name || ''}
            </span>
          </div>
        </div>
        <div className="flex justify-between w-full">
          {data?.immediate ? (
            <div className="flex gap-1">
              <SpanIcon className="text-lg text-green-400" />
              <span className="text-sm text-green-400 font-Regular">فوری</span>
            </div>
          ) : (
            <span className={classNames('text-xs font-Regular')}>
              {data?.published_date &&
                moment(moment(new Date(data?.published_date)))
                  .locale('fa')
                  .from(new Date())}
            </span>
          )}

          {data?.ad_price && (
            <div className="flex items-center text-[#1A1A1A] text-md font-Medium gap-1">
              {discountedAdvertisementPrice(
                Number(data?.ad_price),
                data?.discount_amount,
              ).toLocaleString()}
              <span className="text-xs">تومان</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderCard;
